import { defineMessages } from "react-intl";

export const messages = defineMessages({
  buttonLabel: {
    id: "dashboardview.ongoingmeetingcard.button.label",
    defaultMessage: "Go to meeting session",
    description: "Action button for ongoing meeting card",
  },
});
